export default class Ueberweisung {
    // BT-84
    iban = ""
    // BT-86
    bic = ""
    // BT-85
    kontoinhaber = ""

    get notEmpty(): boolean {
        return this.iban.trim().length > 0 || this.bic.trim().length > 0 || this.kontoinhaber.trim().length > 0
    }

    toJSON() {
        return {
            iban: this.stripWhitespace(this.iban),
            bic: this.bic,
            kontoinhaber: this.kontoinhaber,
        }
    }

    stripWhitespace(text: string) {
        return text.split(" ").join("")
    }
}
